import { type MouseEvent, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Close } from '@air/next-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

import { useAppliedFiltersCount } from '~/hooks/filters/useAppliedFiltersCount';
import { useApplyFilters } from '~/hooks/filters/useApplyFilters';
import { clearAllFiltersAction } from '~/store/filters/actions';

export type PrivateSearchClearButtonProps = Pick<ButtonProps, 'onClick'>;

export const PrivateSearchClearButton = memo(({ onClick: _onClick }: PrivateSearchClearButtonProps) => {
  const { filtersCanBeSaved } = useAppliedFiltersCount();
  const { clearSearchAndFilters } = useApplyFilters();
  const dispatch = useDispatch();

  const onClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      clearSearchAndFilters();
      dispatch(clearAllFiltersAction());
      _onClick?.(event);
    },
    [_onClick, clearSearchAndFilters, dispatch],
  );

  return (
    <Button
      appearance="outline"
      color="grey"
      data-testid="CLEAR_FILTER_BUTTON"
      onClick={onClick}
      prefix={<Close className="size-3" />}
      size="small"
    >
      {filtersCanBeSaved ? 'Clear all' : 'Clear'}
    </Button>
  );
});

PrivateSearchClearButton.displayName = 'PrivateSearchClearButton';
